module.exports = __webpack_public_path__ + "static/media/icon_i.780660da.svg";